export enum NOTA_DEBITO_EXTERNO_TYPES {
  NDEXT_SET_VIEW = 'NDEXT_SET_VIEW',
  NDEXT_SET_FORM_CLIENTE = 'NDEXT_SET_FORM_CLIENTE',
  NDEXT_HANDLE_ERRORS_CLIENTE = 'NDEXT_HANDLE_ERRORS_CLIENTE',
  NDEXT_SET_FORM_PRODUCTO = 'NDEXT_SET_FORM_PRODUCTO',
  NDEXT_HANDLE_ERRORS_PRODUCTO = 'NDEXT_HANDLE_ERRORS_PRODUCTO',
  NDEXT_SET_PRODUCTOS = 'NDEXT_SET_PRODUCTOS',
  NDEXT_SET_PRODUCTO_EDIT = 'NDEXT_SET_PRODUCTO_EDIT',
  NDEXT_SET_PRODUCTO_INDEX = 'NDEXT_SET_PRODUCTO_INDEX',

  NDEXT_ACTIVE_MODAL_EDITAR_PRODUCTO = 'NDEXT_ACTIVE_MODAL_EDITAR_PRODUCTO',
  NDEXT_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'NDEXT_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
  NDEXT_ACTIVE_MODAL_QUITAR_TODO = 'NDEXT_ACTIVE_MODAL_QUITAR_TODO',
  NDEXT_ACTIVE_MODAL_EMITIR = 'NDEXT_ACTIVE_MODAL_EMITIR',
  NDEXT_ACTIVE_MODAL_EMITIDO = 'NDEXT_ACTIVE_MODAL_EMITIDO',
  NDEXT_ACTIVE_MODAL_MAS_OPCIONES = 'NDEXT_ACTIVE_MODAL_MAS_OPCIONES',
  NDEXT_ACTIVE_MODAL_ENVIAR_CORREO = 'NDEXT_ACTIVE_MODAL_ENVIAR_CORREO',
  NDEXT_ACTIVE_MODAL_IMPRIMIR = 'NDEXT_ACTIVE_MODAL_IMPRIMIR',
  NDEXT_ACTIVE_MODAL_ANULAR = 'NDEXT_ACTIVE_MODAL_ANULAR',
  NDEXT_ACTIVE_MODAL_ANULADO = 'NDEXT_ACTIVE_MODAL_ANULADO',
  
  NDEXT_SET_CLIENTE_ENCONTRADO = 'NDEXT_SET_CLIENTE_ENCONTRADO',
  NDEXT_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'NDEXT_ACTIVE_MODAL_CLIENTE_ENCONTRADO',
  
  NDEXT_SET_TOTAL_ORIGINAL = 'NDEXT_SET_TOTAL_ORIGINAL',
  NDEXT_SET_PRODUCTOS_ORIGINAL= 'NDEXT_SET_PRODUCTOS_ORIGINAL',

  NDEXT_SET_QR_CODE = 'NDEXT_SET_QR_CODE',
  NDEXT_SET_RESPONSE_EMITIR = 'NDEXT_SET_RESPONSE_EMITIR',

  NDEXT_SET_CALCULOS_PRODUCTO = 'NDEXT_SET_CALCULOS_PRODUCTO',
  NDEXT_SET_CALCULOS_GENERALES = 'NDEXT_SET_CALCULOS_GENERALES',

  NDEXT_RESTART_FORM_PRODUCTO = 'NDEXT_RESTART_FORM_PRODUCTO',
  NDEXT_RESTART_ALL = 'NDEXT_RESTART_ALL',
  NDEXT_SET_CLIENTE_ENDONTRADO = 'NDEXT_SET_CLIENTE_ENDONTRADO',
  NDEXT_ACTIVE_MODAL_CLIENTE_ENDONTRADO = 'NDEXT_ACTIVE_MODAL_CLIENTE_ENDONTRADO',

  NDEXT_ACTIVE_MODAL_DOCUMENTO_FISICO = 'NDEXT_ACTIVE_MODAL_DOCUMENTO_FISICO',
  NDEXT_SET_DOCUMENTO_FISICO = 'NDEXT_SET_DOCUMENTO_FISICO',
  NDEXT_FORMOBSERVACIONES_HANDLE_CHANGE = 'NDEXT_FORMOBSERVACIONES_HANDLE_CHANGE',
}
